class TruckConfiguratorSettings {
    _apiBaseUrl;
    _antiForgeryToken;
    _itemId;
    _languageId;
    _marketId;
    _marketCode;
    _pageViewTitle;
    _truckRenderWebsocketUrl;
    _timeoutErrorMessage;

    constructor() {
        if (TruckConfiguratorSettings.instance) {
            return TruckConfiguratorSettings.instance;
        }
        this._initSettings();
        TruckConfiguratorSettings.instance = this;
    }

    get apiBaseUrl() {
        return this._apiBaseUrl;
    }

    get antiForgeryToken() {
        return this._antiForgeryToken;
    }

    get itemId() {
        return this._itemId;
    }

    get languageId() {
        return this._languageId;
    }

    get marketId() {
        return this._marketId;
    }

    get marketCode() {
        return this._marketCode;
    }

    get pageViewTitle() {
        return this._pageViewTitle;
    }

    get truckRenderWebsocketUrl() {
        return this._truckRenderWebsocketUrl;
    }

    get timeoutErrorMessage() {
        return this._timeoutErrorMessage;
    }

    _initSettings() {
        this._pageViewTitle = 'Truck configurator';
        this._apiBaseUrl = this._initApiBaseUrl();
        this._antiForgeryToken = this._initRequestVerificationToken();
        this._initValueFromHiddenInput('ItemId', '_itemId');
        this._initValueFromHiddenInput('LanguageId', '_languageId');
        this._initValueFromHiddenInput('MarketId', '_marketId');
        this._initValueFromHiddenInput('MarketCode', '_marketCode');
        this._initValueFromHiddenInput('RenderingWebsocketUrl', '_truckRenderWebsocketUrl');
        this._initValueFromHiddenInput('TimeoutErrorMessage', '_timeoutErrorMessage');
    }

    _initApiBaseUrl() {
        const truckConfiguratorElement = document.querySelector('.truckconfigurator');

        if (!truckConfiguratorElement) {
            throw new Error('Truck configurator container element not found');
        }

        const url = truckConfiguratorElement.dataset.api;

        if (!url) {
            throw new Error('No value is retrieved from data-api attribute on truck configurator container element');
        }

        return url + '/api/feature/truckconfigurator';
    }

    _initRequestVerificationToken() {
        const antiForgeryTokenMetaElement = document.querySelector('meta[name=anti-forgery-token]');

        if (!antiForgeryTokenMetaElement) {
            throw new Error('Meta element with name="anti-forgery-token" not found');
        }

        const antiForgeryToken = antiForgeryTokenMetaElement.getAttribute('content');

        if (!antiForgeryToken) {
            throw new Error('Anti-forgery-token value is not found on content attribute');
        }

        return antiForgeryToken;
    }

    _initValueFromHiddenInput(id, field) {
        const hiddenInputElement = document.getElementById(id);

        if (!hiddenInputElement) {
            throw new Error(`Could not find hidden input element with id ${id}`);
        }

        this[field] = hiddenInputElement.value;
    }
}

export default TruckConfiguratorSettings;